import { Component, Input } from '@angular/core';
import { Injectable } from '@angular/core';
import { Stormpath, LoginService } from '../stormpath/stormpath.service';
export var LoginComponent = (function () {
    function LoginComponent(stormpath, loginService) {
        this.stormpath = stormpath;
        this.loginService = loginService;
    }
    LoginComponent.prototype.ngOnInit = function () {
        this.user$ = this.stormpath.user$;
        this.loggedIn$ = this.user$.map(function (user) { return !!user; });
        this.loginFormModel = {
            login: '',
            password: ''
        };
    };
    LoginComponent.prototype.login = function (form) {
        var _this = this;
        this.error = null;
        this.stormpath.login(this.loginFormModel)
            .subscribe(null, function (error) {
            _this.error = error.message;
        });
    };
    LoginComponent.prototype.forgot = function () {
        this.loginService.forgotPassword();
    };
    LoginComponent.decorators = [
        { type: Component, args: [{
                    selector: 'login-form',
                    template: "<template #defaultTemplate>\n<form class=\"form-horizontal\" #form=\"ngForm\" (ngSubmit)=\"login(form.value)\" autocomplete=\"off\">\n  <div class=\"form-group\">\n    <label for=\"loginField\" class=\"col-sm-3 control-label\">Email</label>\n    <div class=\"col-sm-9\">\n      <input class=\"form-control\" name=\"login\" id=\"loginField\" type=\"text\" required [(ngModel)]=\"loginFormModel.login\">\n    </div>\n  </div>\n  <div class=\"form-group\">\n    <label for=\"passwordField\" class=\"col-sm-3 control-label\">Password</label>\n    <div class=\"col-sm-9\">\n      <input class=\"form-control\" name=\"password\" id=\"passwordField\" type=\"password\" required [(ngModel)]=\"loginFormModel.password\">\n    </div>\n  </div>\n\n  <div class=\"form-group\">\n    <div class=\"col-xs-10 col-xs-offset-3 text-left\">\n      <a href=\"#\" (click)=\"forgot(); false\">&nbsp;Forgot Password?</a>\n    </div>\n  </div>\n\n  <div *ngIf=\"error\" class=\"alert alert-danger\">{{error}}</div>\n  <button id=\"loginBtn\" type=\"submit\" class=\"btn btn-primary pull-right\">Login</button>\n</form>\n</template>\n<template\n  [ngTemplateOutlet]=\"customTemplate || defaultTemplate\">\n</template>"
                },] },
        { type: Injectable },
    ];
    /** @nocollapse */
    LoginComponent.ctorParameters = function () { return [
        { type: Stormpath, },
        { type: LoginService, },
    ]; };
    LoginComponent.propDecorators = {
        'customTemplate': [{ type: Input },],
    };
    return LoginComponent;
}());
//# sourceMappingURL=login.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-stormpath/dist/esm/src/login/login.component.js
// module id = 569
// module chunks = 0